import React from 'react';
import { LegalPage } from '@components/LegalPage';
import { RZTermsContent } from '@components/RZTermsContent';
import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';

const RZRules = () => (
  <LegalPage seoTitle={rachelZoePageData.rules.seoText}>
    <RZTermsContent />
  </LegalPage>
);

export default RZRules;
